const parseEmailList = (rawValue: string | undefined): Set<string> => {
  if (!rawValue) return new Set();

  return new Set(
    rawValue
      .split(",")
      .map((entry) => entry.trim().toLowerCase())
      .filter(Boolean)
  );
};

const adminEmails = parseEmailList(import.meta.env.VITE_ADMIN_EMAILS);

export const hasAdminEmailsConfigured = adminEmails.size > 0;

export const isAdminEmail = (email?: string | null): boolean => {
  if (!email) return false;
  return adminEmails.has(email.trim().toLowerCase());
};
